import WhatsAppInbox from '../components/WhatsApp/WhatsAppInbox'

export default function WhatsAppPage() {
  return (
    <div className="card" style={{ height: 'calc(100vh - 100px)', padding: 0, overflow: 'hidden' }}>
      <WhatsAppInbox />
    </div>
  )
}
